<template>
  <li
    v-if="!hidden"
    tabindex="0"
    class="dropdown__item"
    @click="optionClicked"
  >
    <slot />
  </li>
</template>

<script>
import DropdownOption from '../../mixins/DropdownOption'

export default {
  mixins: [
    DropdownOption
  ]
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// node_modules/pro4all-ui/ui-kit/components/Dropdown/BaseDropdownOption.vue